import { useState } from "react";
import "./Header.css";
import Logo from "./Logo.png";

export default function Header({ onContactClick }) {
  const [showSidebar, setShowSidebar] = useState(false);
  const [showServicesDropdown, setShowServicesDropdown] = useState(false);


  const handleServicesClick = (isCorporate = false) => {
    // Scroll to services section
    const servicesSection = document.getElementById("services");
    if (servicesSection) {
      const sectionRect = servicesSection.getBoundingClientRect();
      const sectionTop = sectionRect.top + window.scrollY;
      const headerHeight = 80;
      // Scroll higher so "Our Services" title is visible below menu bar
      const targetScroll = sectionTop - headerHeight - 40;
      window.scrollTo({ top: Math.max(0, targetScroll), behavior: "smooth" });
      // Dispatch event to set toggle state
      setTimeout(() => {
        const event = new CustomEvent('setServicesToggle', { detail: { isCorporate } });
        window.dispatchEvent(event);
      }, 500); // Small delay to ensure scroll completes
    }
    setShowServicesDropdown(false);
    setShowSidebar(false);
  };

  const handleClientsClick = (e) => {
    e.preventDefault();
    const clientsSection = document.getElementById("clients");
    if (clientsSection) {
      clientsSection.scrollIntoView({ behavior: "smooth", block: "start" });
    }
    setShowSidebar(false);
  };

  const handleWhoWeServeClick = (e) => {
    e.preventDefault();
    const whoWeServeSection = document.getElementById("who-we-serve");
    if (whoWeServeSection) {
      const sectionRect = whoWeServeSection.getBoundingClientRect();
      const sectionTop = sectionRect.top + window.scrollY;
      const headerHeight = 80;
      const targetScroll = sectionTop - headerHeight;
      window.scrollTo({ top: Math.max(0, targetScroll), behavior: "smooth" });
    }
    setShowSidebar(false);
  };

  const handleBuyTheBookClick = (e) => {
    e.preventDefault();
    const bookSection = document.getElementById("book");
    const whoWeServeSection = document.getElementById("who-we-serve");
    if (bookSection) {
      const bookRect = bookSection.getBoundingClientRect();
      const bookTop = bookRect.top + window.scrollY;
      const headerHeight = 80;
      let targetScroll = bookTop - headerHeight;
      
      // If sticky section exists and we need to scroll past it
      if (whoWeServeSection) {
        const whoWeServeRect = whoWeServeSection.getBoundingClientRect();
        const whoWeServeTop = whoWeServeRect.top + window.scrollY;
        const whoWeServeHeight = whoWeServeSection.offsetHeight;
        const whoWeServeBottom = whoWeServeTop + whoWeServeHeight;
        
        // Only scroll past if book section is after sticky section
        if (bookTop > whoWeServeTop) {
          // Check if sticky is currently in view
          if (whoWeServeRect.top < window.innerHeight && whoWeServeRect.bottom > 0) {
            targetScroll = Math.max(targetScroll, whoWeServeBottom - headerHeight);
          }
        }
      }
      
      window.scrollTo({ top: Math.max(0, targetScroll), behavior: "smooth" });
    }
    setShowSidebar(false);
  };

  const handleTestimonialsClick = (e) => {
    e.preventDefault();
    const testimonialsSection = document.getElementById("testimonials");
    const whoWeServeSection = document.getElementById("who-we-serve");
    if (testimonialsSection) {
      const testimonialsRect = testimonialsSection.getBoundingClientRect();
      const testimonialsTop = testimonialsRect.top + window.scrollY;
      const headerHeight = 80;
      let targetScroll = testimonialsTop - headerHeight;
      
      // If sticky section exists and we need to scroll past it
      if (whoWeServeSection) {
        const whoWeServeRect = whoWeServeSection.getBoundingClientRect();
        const whoWeServeTop = whoWeServeRect.top + window.scrollY;
        const whoWeServeHeight = whoWeServeSection.offsetHeight;
        const whoWeServeBottom = whoWeServeTop + whoWeServeHeight;
        
        // Only scroll past if testimonials section is after sticky section
        if (testimonialsTop > whoWeServeTop) {
          // Check if sticky is currently in view
          if (whoWeServeRect.top < window.innerHeight && whoWeServeRect.bottom > 0) {
            targetScroll = Math.max(targetScroll, whoWeServeBottom - headerHeight);
          }
        }
      }
      
      window.scrollTo({ top: Math.max(0, targetScroll), behavior: "smooth" });
    }
    setShowSidebar(false);
  };

  const handleFaqClick = (e) => {
    e.preventDefault();
    const faqSection = document.getElementById("faq");
    const whoWeServeSection = document.getElementById("who-we-serve");
    if (faqSection) {
      const faqRect = faqSection.getBoundingClientRect();
      const faqTop = faqRect.top + window.scrollY;
      const headerHeight = 80;
      // Scroll so "Frequently Asked Questions" title is slightly below menu bar
      let targetScroll = faqTop - headerHeight - 20;
      
      // If sticky section exists and we need to scroll past it
      if (whoWeServeSection) {
        const whoWeServeRect = whoWeServeSection.getBoundingClientRect();
        const whoWeServeTop = whoWeServeRect.top + window.scrollY;
        const whoWeServeHeight = whoWeServeSection.offsetHeight;
        const whoWeServeBottom = whoWeServeTop + whoWeServeHeight;
        
        // Only scroll past if FAQ section is after sticky section
        if (faqTop > whoWeServeTop) {
          // Check if sticky is currently in view
          if (whoWeServeRect.top < window.innerHeight && whoWeServeRect.bottom > 0) {
            targetScroll = Math.max(targetScroll, whoWeServeBottom - headerHeight - 20);
          }
        }
      }
      
      window.scrollTo({ top: Math.max(0, targetScroll), behavior: "smooth" });
    }
    setShowSidebar(false);
  };

  const handleWhyUsClick = (e) => {
    e.preventDefault();
    const whyUsSection = document.getElementById("why-us");
    if (whyUsSection) {
      const sectionRect = whyUsSection.getBoundingClientRect();
      const sectionTop = sectionRect.top + window.scrollY;
      const headerHeight = 80;
      // Scroll so "Better Results. Less Time." text is just below menu bar
      const targetScroll = sectionTop - headerHeight - 20;
      window.scrollTo({ top: Math.max(0, targetScroll), behavior: "smooth" });
    }
    setShowSidebar(false);
  };

  const handleMeetSimonClick = (e) => {
    e.preventDefault();
    const meetSimonSection = document.getElementById("meet-simon");
    if (meetSimonSection) {
      meetSimonSection.scrollIntoView({ behavior: "smooth", block: "start" });
    }
    setShowSidebar(false);
  };

  return (
    <header className="main-page-header">
      <div className="main-page-header-container">
        <div className="logo">
          <img src={Logo} alt="Speak with Simon Logo" />
          <span>SPEAK WITH SIMON</span>
        </div>
        <div className="menu" onClick={() => setShowSidebar(true)}>
          <svg
            className="menu-icon"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4 18L20 18"
              stroke="#ffffff"
              strokeWidth="2"
              strokeLinecap="round"
            />
            <path
              d="M4 12L20 12"
              stroke="#ffffff"
              strokeWidth="2"
              strokeLinecap="round"
            />
            <path
              d="M4 6L20 6"
              stroke="#ffffff"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
        </div>
        <div className={"side-bar" + (showSidebar ? " activated" : "")}>
          <div className="side-bar-header">
            <div className="logo">
              <img
                src="https://placehold.co/40x40/667eea/FFFFFF?text=S"
                alt="Speak with Simon Logo"
              />
              <span>SPEAK WITH SIMON</span>
            </div>
            <svg
              onClick={() => setShowSidebar(false)}
              className="close-icon"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 50 50"
              fill="#ffffff"
            >
              <path d="M 9.15625 6.3125 L 6.3125 9.15625 L 22.15625 25 L 6.21875 40.96875 L 9.03125 43.78125 L 25 27.84375 L 40.9375 43.78125 L 43.78125 40.9375 L 27.84375 25 L 43.6875 9.15625 L 40.84375 6.3125 L 25 22.15625 Z"></path>
            </svg>
          </div>
          <nav className="main-nav-sidebar">
            <ul>
              <li>
                <a href="#why-us" onClick={handleWhyUsClick}>Why Us</a>
              </li>
              <li>
                <div 
                  className="services-dropdown-wrapper"
                  onMouseEnter={() => setShowServicesDropdown(true)}
                  onMouseLeave={() => setShowServicesDropdown(false)}
                >
                  <a 
                    href="#services"
                    onClick={(e) => {
                      e.preventDefault();
                      handleServicesClick(false);
                    }}
                  >
                    Services
                  </a>
                  {showServicesDropdown && (
                    <div 
                      className="services-dropdown"
                      onMouseEnter={() => setShowServicesDropdown(true)}
                      onMouseLeave={() => setShowServicesDropdown(false)}
                    >
                      <a
                        href="#services"
                        onClick={(e) => {
                          e.preventDefault();
                          handleServicesClick(false);
                        }}
                      >
                        1-on-1
                      </a>
                      <a
                        href="#services"
                        onClick={(e) => {
                          e.preventDefault();
                          handleServicesClick(true);
                        }}
                      >
                        Corporate
                      </a>
                    </div>
                  )}
                </div>
              </li>
              <li>
                <a href="#meet-simon" onClick={handleMeetSimonClick}>Meet Simon</a>
              </li>
              <li>
                <a href="#who-we-serve" onClick={handleWhoWeServeClick}>Who We Serve</a>
              </li>
              <li>
                <a href="#book" onClick={handleBuyTheBookClick}>Buy The Book</a>
              </li>
              <li>
                <a href="#testimonials" onClick={handleTestimonialsClick}>Testimonials</a>
              </li>
              <li>
                <a href="#faq" onClick={handleFaqClick}>FAQ</a>
              </li>
              <li>
                <a
                  href="#contact"
                  className="btn btn-primary"
                  onClick={(e) => {
                    e.preventDefault();
                    setShowSidebar(false);
                    onContactClick && onContactClick();
                  }}
                >
                  Contact
                </a>
              </li>
            </ul>
          </nav>
        </div>
        <nav className="main-nav">
          <ul>
            <li>
              <a href="#why-us" onClick={handleWhyUsClick}>Why Us</a>
            </li>
            <li>
              <div 
                className="services-dropdown-wrapper"
                onMouseEnter={() => setShowServicesDropdown(true)}
                onMouseLeave={() => setShowServicesDropdown(false)}
              >
                <a 
                  href="#services"
                  onClick={(e) => {
                    e.preventDefault();
                    handleServicesClick(false);
                  }}
                >
                  Services
                </a>
                {showServicesDropdown && (
                  <div 
                    className="services-dropdown"
                    onMouseEnter={() => setShowServicesDropdown(true)}
                    onMouseLeave={() => setShowServicesDropdown(false)}
                  >
                    <a
                      href="#services"
                      onClick={(e) => {
                        e.preventDefault();
                        handleServicesClick(false);
                      }}
                    >
                      1-on-1
                    </a>
                    <a
                      href="#services"
                      onClick={(e) => {
                        e.preventDefault();
                        handleServicesClick(true);
                      }}
                    >
                      Corporate
                    </a>
                  </div>
                )}
              </div>
            </li>
            <li>
              <a href="#meet-simon" onClick={handleMeetSimonClick}>Meet Simon</a>
            </li>
            <li>
              <a href="#who-we-serve" onClick={handleWhoWeServeClick}>Who We Serve</a>
            </li>
            <li>
              <a href="#book" onClick={handleBuyTheBookClick}>Buy The Book</a>
            </li>
            <li>
              <a href="#testimonials" onClick={handleTestimonialsClick}>Testimonials</a>
            </li>
            <li>
              <a href="#faq" onClick={handleFaqClick}>FAQ</a>
            </li>
            <li>
              <a
                href="#contact"
                className="btn btn-primary"
                onClick={(e) => {
                  e.preventDefault();
                  onContactClick && onContactClick();
                }}
              >
                Contact
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
}
